export const totalNodes = (nodes, base = {}) => {
  const result = { ...base };
  ['diseno', 'real'].forEach(field => {
    const values = nodes.map(node => node[`${field}_conocido`] ?? node[field]).filter(value => value != null);
    result[`${field}_conocido`] = values.length ? Number(values.reduce((sum, value) => sum + value, 0).toFixed(2)) : null;
    result[`${field}_pendiente`] = nodes.some(node => node[`${field}_pendiente`] ?? node[field] == null);
    result[field] = result[`${field}_pendiente`] ? null : result[`${field}_conocido`];
  });
  result.saldo = result.diseno == null || result.real == null ? null : Number((result.diseno - result.real).toFixed(2));
  result.desviacion = result.saldo == null || result.diseno <= 0 ? null : (result.real - result.diseno) / result.diseno * 100;
  result.estado = result.saldo == null ? 'Pendiente' : result.saldo < 0 ? 'Excedido' : 'Dentro de presupuesto';
  return result;
};

export const filterCustomers = (customers, search, product) => customers
  .filter(customer => customer.cliente.toLocaleLowerCase().includes(search.toLocaleLowerCase()))
  .map(customer => {
    const opportunities = customer.oportunidades.map(opportunity => {
      const selected = opportunity.lineas.filter(line => !product || line.producto === product);
      const shared = product && selected.length && opportunity.lineas.some(line => line.sintetica && line.producto === 'Laboral compartido');
      const lines = shared ? selected.map(line => ({ ...line, real_pendiente: true,
        warnings: [...(line.warnings || []), 'Costo compartido por OP excluido del filtro de producto'],
      })) : selected;
      return totalNodes(lines, { ...opportunity, lineas: lines });
    }).filter(opportunity => opportunity.lineas.length);
    return totalNodes(opportunities, { ...customer, oportunidades: opportunities });
  }).filter(customer => customer.oportunidades.length);